// extracted by mini-css-extract-plugin
export default {"hardness":"hlq6R","popoverInfo":"aEb88","popover":"l8ItU","name":"qH7I2","icon":"VAEWs","value":"B0Kgh","text":"fdHjl"};